/**
 * OTO Merch Shopify Theme JavaScript
 */

document.addEventListener('DOMContentLoaded', () => {
  initHeaderScroll();
  initShopifyCartWatcher();
  initProductAccordion();
});

/**
 * Header Scroll Shrink Effect
 */
function initHeaderScroll() {
  const header = document.getElementById('shopify-section-header');
  if (!header) return;

  const handleScroll = () => {
    if (window.scrollY > 50) {
      header.classList.add('scrolled');
    } else {
      header.classList.remove('scrolled');
    }
  };

  window.addEventListener('scroll', handleScroll);
  handleScroll();
}

/**
 * Shopify Ajax Cart Watcher
 */
function initShopifyCartWatcher() {
  const cartBadge = document.getElementById('CartCount');
  
  window.updateCartBadge = function() {
    fetch('/cart.js')
      .then(response => response.json())
      .then(cart => {
        if (cartBadge) {
          cartBadge.textContent = cart.item_count;
          if (cart.item_count > 0) {
            cartBadge.classList.remove('hidden');
          } else {
            cartBadge.classList.add('hidden');
          }
        }
      })
      .catch(err => console.error('Error fetching cart state:', err));
  };
}

/**
 * Product Detail Page Accordion
 */
function initProductAccordion() {
  window.toggleProductAccordion = function(itemId) {
    const item = document.getElementById(itemId);
    if (!item) return;

    if (item.classList.contains('open')) {
      item.classList.remove('open');
    } else {
      item.classList.add('open');
    }
  };
}
